// Redondeo a pesos enteros (decisión de Fefo, 30-oct-2026): no hay deudas ni
// saldos a favor de centésimos, y el cierre reparte pesos enteros por unidad: la
// parte de cada unidad se redondea PARA ARRIBA (pesosParaArriba) y lo que sobra,
// unos pocos pesos, queda en el fondo.
//
// Regla: menos de 50 centésimos se redondea para abajo; 50 o más, para arriba.
// En negativos se aplica igual sobre el valor absoluto (−0,50 → −1, −0,48 → 0),
// así una deuda y un saldo a favor del mismo tamaño redondean igual.

/**
 * Monto redondeado a pesos enteros. Nunca devuelve −0 ni NaN.
 * @param {unknown} v
 * @returns {number}
 */
export function roundPesos(v) {
  const n = Number(v);
  if (!Number.isFinite(n)) return 0;
  // Primero a centésimos exactos: 0,1 + 0,2 + … deja 0,4999… y no debe bajar.
  const centesimos = Math.round(Math.abs(n) * 100);
  const pesos = Math.floor((centesimos + 50) / 100);
  if (pesos === 0) return 0;
  return n < 0 ? -pesos : pesos;
}

/**
 * Monto redondeado a pesos enteros PARA ARRIBA (centésimos → peso siguiente). Lo
 * usa el cierre para la parte de cada unidad: dos unidades con la misma parte
 * pagan lo mismo y los pocos pesos de más quedan en el fondo (decisión de Fefo,
 * 30-oct-2026). 999,41 → 1.000; 1.000 → 1.000. Nunca negativo.
 * @param {unknown} v
 * @returns {number}
 */
export function pesosParaArriba(v) {
  const n = Number(v);
  if (!Number.isFinite(n) || n <= 0) return 0;
  // Primero a centésimos exactos: 999,9999999 (suma flotante) es 1.000, no 1.001.
  return Math.ceil(Math.round(n * 100) / 100);
}

/**
 * Lo que queda de un pago, en pesos enteros: positivo = deuda, negativo = saldo
 * a favor, 0 = saldado. `remainingAmount` manda (aunque sea 0); si falta, se
 * deriva de amount − paidAmount.
 * @param {{ amount?: unknown, paidAmount?: unknown, remainingAmount?: unknown } | null | undefined} p
 * @returns {number}
 */
export function saldoEnPesos(p) {
  if (!p) return 0;
  const rem = p.remainingAmount != null
    ? Number(p.remainingAmount)
    : (Number(p.amount) || 0) - (Number(p.paidAmount) || 0);
  return roundPesos(rem);
}
